import React, { Component } from "react";

//<div>
  //<a
    //id="Help"
    //href="https://goo.gl/forms/68rt37pElAEhk3M82"
    //target="_blank"
    //rel="noopener noreferrer"
  //>      
    //Join the create account wish list - It's Free. 
  //</a>              
//</div>

//<div>Create an Account, It's Free</div>

//<div>Join the wish list - Request a demo - Meet your needs. Start today.</div>

//<div>Join the wish list - Access a demo - Meet your needs. Start today.</div>

//<div>Get a free e-voucher - Access a demo - Meet your needs. Start today.</div>

//<div>e-Voucher Discount Code - Demo - Stock up wishes. Join others today.</div>

//<div>1. e-Voucher Discount Code 2. Demo 3. Stock up wishes. Join others today.</div>

class Help extends Component {
  render() {
    return (
      <h3 id="Help">
        <div>1. e-Voucher Discount Code 2. Order 3. Stock up wishes. Join others today.</div>
      </h3>
    );
  }
}

export default Help;
